export default "__VITE_ASSET__CxpPkLc9__"